import React, { Component } from 'react';
import '../styles/SpecialOccasions.css';
import LearnMoreButton from './LearnMoreButton'
import ScrollToTop from 'react-scroll-up'
import TeamBuildingPicture from '../images/Landing/team-building.jpg'
import GiftCardPicture from '../images/Landing/gift-card.jpg'
import ArrowUpIcon from '../images/icons/arrow-up-icon.png'
import { Link } from 'react-router-dom'
import { injectIntl, defineMessages } from "react-intl"
import LiteYouTubeEmbed from './LiteYouTubeEmbed';
class SpecialOccasions extends Component {

  scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  render() {
    const {intl:{formatMessage}} = this.props
    const scrollButtonStyle = {
      left: "calc(50% - 170px /2)",
      position: "absolute",
      transitionDuration: '0.5s'
    }

    return (
      <div className="special-occasions">
        <h2>{formatMessage(messages.title)}</h2>
        <div className="occasions-block">
          <div className="occasion occasion-team-building">
            <img src={TeamBuildingPicture} className="occasion-picture occasion-picture--tb"
              alt="team building" />
            <div className="occasion-square occasion-square--tb">
              <h4>{formatMessage(messages.teamBuildingIntro)}</h4>
              <h3>{formatMessage(messages.teamBuilding)}</h3>
              <p>{formatMessage(messages.teamBuildingMessage)}</p>
              <div className="learn-more-occasions">
                <Link to='/team-building/'>
                  <LearnMoreButton glitch text="En savoir plus"/>
                </Link>
              </div>
            </div>
          </div>
          <div className="occasion occasion-gift-card">
            <img src={GiftCardPicture} className="occasion-picture occasion-picture--gc"
              alt="gift card" />
            <div className="occasion-square occasion-square--gc">
              <h4>{formatMessage(messages.giftCardIntro)}</h4>
              <h3>{formatMessage(messages.giftCard)}</h3>
              <p>{formatMessage(messages.giftCardMessage)}</p>
              <div className="learn-more-occasions">
                <Link to='/carte-cadeaux/'>
                  <LearnMoreButton glitch text={formatMessage(messages.knowMore)}/>
                </Link>
              </div>
            </div>
          </div>
        </div>
		<div className="more-info">
			<h2>One Hour escape game Paris : mais qu'est ce que c'est ?</h2>
			Concept venu tout droit du Japon, l’escape game est LE divertissement de jeu d'évasion du moment. Plongés dans des univers aussi variés qu’insolites (de véritables enquêtes policières, un escape horreur, une aventure souterraine), vous avez une heure pour récolter des indices et résoudre des séries d’énigmes dans le but de vous échapper du lieu ou réussir votre objectif avant la fin du temps imparti.
			<p><strong>One Hour escape game Paris</strong> est le jeu d’équipe par excellence, créé en 2016, vous devrez faire appel à votre capacité d’analyse et à votre sens de l’observation afin de vous en sortir ! Communication et esprit d’équipe seront les maîtres mots qui vous guideront vers la victoire.</p>
			<p>One Hour est jouable de 2 joueurs (idéal pour une sortie en couple) jusqu’à 5 joueurs en équipe. Nous disposons de <strong>5 thèmes d’escape game différents</strong> à Paris permettant ainsi de jouer jusqu’à 25 personnes en même temps. Spécialisé dans l’escape game horreur, l'escape game immersif, ou enquête policière One Hour escape game est la sortie idéale en famille, entre amis ou entre collègues. Nous proposons également des formules pour anniversaire escape game, enterrement de vie de garçon et jeune fille et tout évènement spécial.
			</p>
      <LiteYouTubeEmbed videoId="CoZAsXBKGXM" title="Vidéo One Hour" />
			<h3><b>Des scénarios inédits créés sur mesure</b></h3>
			<p>Nos escape game sont des créations originales crées par des passionnés souhaitant mettre en avant :</p>
			<ul>
				<li><strong>une immersion, des décors et effets spéciaux</strong> qui vous feront vivre un véritable film et vous feront pousser des woooow, des oooooh ou même des ahhhh quand un psychopathe sanguinaire vous poursuivra :)</li>
				<li><strong>un gameplay inédit</strong>, car nous ne souhaitons pas "simplement" vous faire résoudre des énigmes, nos escape game ont des mécaniques de jeu originales et variées !</li>
				<li><strong>des surfaces de jeux généreuses</strong> mises en avant par une scénographie étudiée pour vous <strong>retourner le cerveau</strong> !</li>
			</ul>
			<h3><b>L'art de sublimer une partie de jeu</b></h3>
			<p>Nos escape game sont étudiés pour <strong>s'adapter à tout type d'équipe</strong>. Nous estimons qu'une équipe de débutant ne doit pas être frustrée par un jeu trop dur tout comme nous souhaitons que des experts rencontrent de véritables difficultés. Ainsi, chaque jeu aura un gameplay qui s'adaptera en direct durant votre partie. Mécanisme, étape de jeu, énigme, actions du maître du jeu, tout le jeu s'adaptera créant une expérience unique pour votre partie.</p>
			<p>De la même manière, nos jeux et mécanismes <strong>s'adapteront suivant le nombre de joueurs</strong> qui composent votre équipe.</p>
			<p>Nos maîtres du jeu sont formés pour vous accompagner durant votre aventure. Bien plus qu'un simple guide leur action sera déterminante, tantôt adjuvant, ennemi ou personnage primordial de l'aventure, <strong>One Hour a dès sa création mis en avant le rôle du gamemaster</strong> afin de créer des aventures uniques.</p>
			<h3><b>Prix et awards</b></h3>
			<p>Grâce à l'originalité de ses aventures, les soins apportés aux décors, aux énigmes et à la touche supplémentaire apportée par nos gamemaster <strong>One Hour a remporté de nombreux prix</strong> aux Escape Awards (meilleur escape game de Paris) et au Terpeca (meilleur escape game du monde).</p>
			<p>Sélectionné au Terpeca depuis 4 ans parmi les meilleurs escape game du monde nous apportons une attention particulière à rendre votre aventure unique.</p>
			<img class="wp-image-18699" src="../static/media/meilleur-escape-game.jpg" alt="meilleur escape game Paris" height="auto" width="100%"/>
         </div>
      </div>
    );
  }
}

const messages = defineMessages({
  title: {
    id: 'specialOccasion.title',
    defaultMessage: 'Occasions spéciales'
  },
  teamBuildingIntro: {
    id: 'specialOccasion.teamBuildingIntro',
    defaultMessage: 'Découvrez notre offre'
  },
  teamBuilding: {
    id: 'specialOccasion.teamBuilding',
    defaultMessage: 'Team building'
  },
  teamBuildingMessage: {
    id: 'specialOccasion.teamBuildingMessage',
    defaultMessage: 'Vous souhaitez organiser un team building à Paris au sein de One Hour ? Privatisez nos locaux pour une journée inoubliable !'
  },
  giftCardIntro: {
    id: 'specialOccasion.giftCardIntro',
    defaultMessage: 'Offrez une'
  },
  giftCard: {
    id: 'specialOccasion.giftCard',
    defaultMessage: 'carte cadeaux'
  },
  giftCardMessage: {
    id: 'specialOccasion.giftCardMessage',
    defaultMessage: 'Vous souhaitez organiser un team building à Paris au sein de One Hour ? Privatisez nos locaux pour une journée inoubliable !'
  },
  knowMore: {
    id: 'specialOccasion.knowMore',
    defaultMessage: 'En savoir plus'
  },
  backUp: {
    id: 'specialOccasion.backUp',
    defaultMessage: 'Retour en haut'
  },
  Moreinfo: {
    id: 'more-info.Moreinfo',
    defaultMessage: "One Hour escape game Paris : c'est quoi ?"
  },
  MoreinfoMessage1: {
    id: 'more-info.MoreinfoMessage1',
    defaultMessage: "Concept venu tout droit du Japon et de Hongrie, le live Escape Game est LE divertissement de jeu d'évasion du moment. Plongés dans des univers aussi variés qu’insolites (de véritables enquêtes policières, un escape horreur, un escape game enterrement de vie de garçon), vous avez une heure pour récolter des indices et résoudre des séries d’énigmes dans le but de vous échapper de la salle avant la fin du temps imparti."
  },
  MoreinfoMessage2: {
    id: 'more-info.MoreinfoMessage2',
    defaultMessage: "One Hour escape game Paris est un jeu d’équipe par excellence, vous devrez faire appel à votre capacité d’analyse et à votre sens de l’observation afin de vous en sortir ! Communication et esprit d’équipe seront les maîtres mots qui vous guideront vers la victoire."
  },
  MoreinfoMessage3: {
    id: 'more-info.MoreinfoMessage3',
    defaultMessage: "One Hour est jouable de 2 joueurs (idéal pour une sortie en couple) jusqu'à 5 joueurs en équipe. Nous disposons de 5 thèmes d'escape game immersif différents à Paris permettant ainsi de joueur jusqu'à 25 personnes en même temps. Spécialisé dans l'escape game horreur, l'escape game immersif, enquête policière, aventure, fun, One Hour escape game est la sortie idéale en famille, entre amis ou entre collègues. Nous proposons également des formules pour anniversaire, enterrement de vie de garçon et jeune fille et tout évènement spécial."
  },
})

export default injectIntl(SpecialOccasions)



// WEBPACK FOOTER //
// ./src/components/SpecialOccasions.js